/**
 * BQ-069(a) (D-71) - the "לחיוב" box of a new / manual work log. The server honours an explicit value only
 * from the OTE general manager, the project's PM or the customer's account manager (canReassignOrSetBillable),
 * and silently ignores it from anyone else - so for them the box is disabled (the value stays automatic).
 * Unknown (loading / no task yet / the check failed) = enabled, the server still decides.
 */
export function billableBoxDisabled(authority: { allowed?: boolean } | null | undefined): boolean {
  return authority?.allowed === false;
}
